import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/router';
import store from '@/store';

Vue.config.productionTip = false;

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);
Vue.mixin({
    data: function() {
        return {
            get uk() {
                return UIkit
            }
        }
    }
});
// Validator user form
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import moment from 'moment';
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')